import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AdminCustomFactor } from 'src/app/factors/types/factor';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class AdminFactorService {
  private http = inject(HttpClient);

  getAllFactors(): Observable<AdminCustomFactor[]> {
    return this.http.get<AdminCustomFactor[]>(
      `${environment.apiUrl}/admin/factors`,
    );
  }

  setValidated(
    id: string,
    validated: boolean,
  ): Observable<AdminCustomFactor> {
    return this.http.patch<AdminCustomFactor>(
      `${environment.apiUrl}/admin/factors/${id}/validate`,
      { validated },
    );
  }
}
